import { Question } from "../Model/Question";
import { v4 as uuidv4 } from 'uuid';
import { QuestionOptions } from "../Model/QuestionOptions";
import { QuestionGrid } from "../Model/QuestionGrid";
import { QuestionOption } from "../Model/QuestionOption";
import { GridColumn } from "../Model/GridColumn";
import { GridRow } from "../Model/GridRow";
export class QuestionsFactory {
    constructor(sectionsFactory) {
        this.sectionsFactory = sectionsFactory;
    }
    createNewQuestion(form, section, type) {
        const options = {};
        if (['bool', 'multiple'].includes(type)) {
            options.questionOptions = new QuestionOptions([]);
        }
        else if ('grid' === type) {
            options.questionGrid = new QuestionGrid([], []);
        }
        return new Question(form, section, uuidv4(), // id
        '', // name
        '', // description
        true, // status
        false, // useAnswerInFileName
        0, // position
        '100%', // width
        type, // type
        false, // forced
        new Date, // date_created
        new Date, // date_updated
        null, // date_disabled
        [], // sections
        options);
    }
    createQuestionFromState(form, section, state) {
        const sectionsFactory = this.sectionsFactory();
        const sections = state.sections.map(state => sectionsFactory.createSectionFromState(form, state));
        const options = {};
        const optionsFactoriesMap = {
            questionOptions: (options) => new QuestionOptions(options.map(option => this.createQuestionOption(option))),
            questionGrid: ({ columns, rows }) => {
                return new QuestionGrid(columns.map(data => this.createGridColumn(data)), rows.map(data => this.createGridRow(data)));
            },
        };
        for (const [key, value] of Object.entries(state.options)) {
            if (key in optionsFactoriesMap) {
                options[key] = optionsFactoriesMap[key](value);
            }
            else {
                options[key] = value;
            }
        }
        //Nos aseguramos que el objeto de opciones tiene las
        //propiedades necesarias para el tipo de pregunta
        if (['bool', 'multiple'].includes(state.type)) {
            //Creamos el array de opciones de pregunta si es necesario
            if (!options.questionOptions) {
                options.questionOptions = new QuestionOptions([]);
            }
        }
        else if ('grid' === state.type) {
            //Creamos el objteo de rejilla de pregunta si es necesario
            if (!options.questionGrid) {
                options.questionGrid = new QuestionGrid([], []);
            }
        }
        return new Question(form, section, state.id, state.name, state.description, state.status, state.useAnswerInFileName, state.position, state.width, state.type, state.forced, state.date_created, state.date_updated, state.date_disabled, sections, options);
    }
    createQuestionOption(data) {
        return new QuestionOption(data.id, data.text, data.unLock, data.restrict, data.isNA);
    }
    createGridColumn(data) {
        return new GridColumn(data.id, data.name, data.type, data.required);
    }
    createGridRow(data) {
        return new GridRow(data.id, data.text);
    }
}
